import { findGuideTourTargetElement } from '../overlay/utils'

const HEXA_CLICK_HOSTS = new Set(['hexa-v2-button', 'hexa-v2-icon-button'])
const HEXA_TAB_HOST = 'hexa-v2-tab'

const dispatchHexaClick = (element: HTMLElement): void => {
  element.dispatchEvent(
    new CustomEvent('hxClick', { bubbles: true, composed: true })
  )
}

const dispatchHexaTabChange = (tab: HTMLElement): boolean => {
  const title = tab.getAttribute('title')

  if (!title) {
    return false
  }

  const tabsHost = tab.closest('hexa-v2-tabs')

  if (!(tabsHost instanceof HTMLElement)) {
    return false
  }

  tabsHost.dispatchEvent(
    new CustomEvent('hxChangeTab', {
      bubbles: true,
      composed: true,
      detail: { title },
    })
  )

  return true
}

const clickShadowButton = (element: HTMLElement): boolean => {
  const shadowButton = element.shadowRoot?.querySelector('button')

  if (shadowButton instanceof HTMLElement) {
    shadowButton.click()
    return true
  }

  return false
}

const clickNestedButton = (element: HTMLElement): boolean => {
  const nestedButton = element.querySelector('button')

  if (nestedButton instanceof HTMLElement) {
    nestedButton.click()
    return true
  }

  return false
}

const clickHexaTabHost = (element: HTMLElement): void => {
  dispatchHexaTabChange(element)
  clickShadowButton(element)
}

const clickHexaActionHost = (element: HTMLElement): void => {
  dispatchHexaClick(element)
  clickShadowButton(element)
}

const clickDefaultTarget = (element: HTMLElement): void => {
  if (clickShadowButton(element) || clickNestedButton(element)) {
    return
  }

  element.click()
}

/** Programmatically activates a clickable tour target element. */
const forceClickGuideTourElement = (element: HTMLElement): void => {
  const hostTag = element.tagName.toLowerCase()

  if (hostTag === HEXA_TAB_HOST) {
    clickHexaTabHost(element)
    return
  }

  if (HEXA_CLICK_HOSTS.has(hostTag)) {
    clickHexaActionHost(element)
    return
  }

  clickDefaultTarget(element)
}

export { forceClickGuideTourElement }

/** Programmatically activates a tour target (supports Hexa V2 custom events). */
export function forceClickGuideTourTarget(targetId: string): boolean {
  const element = findGuideTourTargetElement(targetId)

  if (!element) {
    if (import.meta.env.DEV) {
      console.warn(
        `[Guide Tour] forceClick target not found for "${targetId}".`
      )
    }

    return false
  }

  forceClickGuideTourElement(element)
  return true
}
